import { PlaceholderPage } from '../components/PlaceholderPage';

export const Partners = () => {
  return (
    <PlaceholderPage
      title="Partners"
      description="The wineries, tourism boards, and businesses we work with to bring you WineryXplorer."
    />
  );
};
